export interface IUserNotes {
    notes: string[];
}

export interface IUserNotesMap {
    [uid: string]: IUserNotes;
}

export const UserNotesPath = `user_notes`;